var _rect, _path, _path2, _path3, _ellipse, _path4, _path5, _path6;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgStatisticApiIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 52,
    height: 52,
    viewBox: "0 0 52 52",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 51,
    height: 51,
    rx: 25.5,
    fill: "#F5F6F8",
    stroke: "#E4E5E8"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.5565 15.333H24.0882C21.0177 15.333 18.9369 18.2064 19.6791 21.1858C20.409 24.1157 20.3706 26.309 18.3982 30.5105L17.3335 31.333L22.0002 29.9997H28.6668L33.6384 30.7751C31.7568 27.715 31.6133 24.7499 32.2393 21.5268C32.8448 18.409 30.7326 15.333 27.5565 15.333Z",
    fill: "#898D9A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24.6668 15.257V13.9998C24.6668 13.2635 25.2638 12.6665 26.0002 12.6665V12.6665C26.7365 12.6665 27.3335 13.2635 27.3335 13.9998V15.3332",
    stroke: "#898D9A",
    strokeWidth: 1.5
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M27.5563 15.333H24.0879C21.0175 15.333 18.9366 18.2064 19.6789 21.1858C20.4088 24.1157 20.3704 26.309 18.3979 30.5105C18.3979 30.5105 22.2111 30.0591 24.6666 29.9997L24.7446 29.9978C25.7375 29.9737 26.3189 29.9596 27.3333 29.9997C29.1652 30.072 30.1863 30.2423 31.9999 30.5105C32.641 30.6053 33.6382 30.7751 33.6382 30.7751C31.7566 27.715 31.6131 24.7499 32.2391 21.5268C32.8446 18.409 30.7323 15.333 27.5563 15.333Z",
    fill: "#898D9A",
    stroke: "#898D9A",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 25.9998,
    cy: 32,
    rx: 9.33333,
    ry: 2,
    fill: "#898D9A",
    stroke: "#898D9A",
    strokeWidth: 1.5
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M37.3017 24.7014C37.8118 23.5294 38.1252 21.5456 36.9577 20.4125",
    stroke: "#898D9A",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M14.7004 24.7013C14.1897 23.5292 13.8753 21.5454 15.0424 20.413",
    stroke: "#898D9A",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M28.6668 38C28.6668 38 28.2224 39.3333 26.0002 39.3333C23.7779 39.3333 23.3335 38 23.3335 38",
    stroke: "#898D9A",
    strokeWidth: 1.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStatisticApiIcon);
export default __webpack_public_path__ + "static/media/statistic-api-icon.41bb72a6bf50d4951ff288efda19a877.svg";
export { ForwardRef as ReactComponent };